/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InboxMessageCreate,
  InboxMessageDelete,
  InboxMessageOnAzure,
  InboxMessageUpdate,
} from '../models/index';
import {
    InboxMessageCreateFromJSON,
    InboxMessageCreateToJSON,
    InboxMessageDeleteFromJSON,
    InboxMessageDeleteToJSON,
    InboxMessageOnAzureFromJSON,
    InboxMessageOnAzureToJSON,
    InboxMessageUpdateFromJSON,
    InboxMessageUpdateToJSON,
} from '../models/index';

export interface ApiInboxMessageAddPostRequest {
    inboxMessageCreate?: InboxMessageCreate;
}

export interface ApiInboxMessageDeleteDeleteRequest {
    inboxMessageDelete?: InboxMessageDelete;
}

export interface ApiInboxMessageGetAllByLanguageCodeGetRequest {
    languageCode?: string;
}

export interface ApiInboxMessageUpdatePutRequest {
    inboxMessageUpdate?: InboxMessageUpdate;
}

/**
 * 
 */
export class InboxMessageApi extends runtime.BaseAPI {

    /**
     */
    async apiInboxMessageAddPostRaw(requestParameters: ApiInboxMessageAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboxMessageOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/InboxMessage/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InboxMessageCreateToJSON(requestParameters['inboxMessageCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboxMessageOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiInboxMessageAddPost(requestParameters: ApiInboxMessageAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboxMessageOnAzure> {
        const response = await this.apiInboxMessageAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiInboxMessageDeleteDeleteRaw(requestParameters: ApiInboxMessageDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/InboxMessage/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InboxMessageDeleteToJSON(requestParameters['inboxMessageDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiInboxMessageDeleteDelete(requestParameters: ApiInboxMessageDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiInboxMessageDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiInboxMessageGetAllByLanguageCodeGetRaw(requestParameters: ApiInboxMessageGetAllByLanguageCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InboxMessageOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['languageCode'] != null) {
            queryParameters['language_code'] = requestParameters['languageCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/InboxMessage/GetAllByLanguageCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InboxMessageOnAzureFromJSON));
    }

    /**
     */
    async apiInboxMessageGetAllByLanguageCodeGet(requestParameters: ApiInboxMessageGetAllByLanguageCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InboxMessageOnAzure>> {
        const response = await this.apiInboxMessageGetAllByLanguageCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiInboxMessageGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InboxMessageOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/InboxMessage/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InboxMessageOnAzureFromJSON));
    }

    /**
     */
    async apiInboxMessageGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InboxMessageOnAzure>> {
        const response = await this.apiInboxMessageGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiInboxMessageUpdatePutRaw(requestParameters: ApiInboxMessageUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/InboxMessage/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InboxMessageUpdateToJSON(requestParameters['inboxMessageUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiInboxMessageUpdatePut(requestParameters: ApiInboxMessageUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiInboxMessageUpdatePutRaw(requestParameters, initOverrides);
    }

}
